/* import __COLOCATED_TEMPLATE__ from './locked-out.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();